import { Link } from "react-router-dom";
import { news } from "@/mocks/content";
import { ListRow } from "@/components/feature/Cards";

export default function ExclusiveZone() {
  const list = news.filter((n) => n.exclusive);
  const lead = list[0];
  const rest = list.slice(1);
  return (
    <section className="border-y border-primary-100 bg-primary-50/50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid gap-8 lg:grid-cols-3">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <p className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-700">
              <span className="inline-block h-3 w-1 rounded-full bg-primary-600" />
              Exclusive Zone
            </p>
            <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-900 md:text-3xl">
              独家内幕专区
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              只此一家的深度内幕，把圈内不愿摆在台面上的来龙去脉摊开给你看。全网都在等的那口瓜，往往先在这里发芽。
            </p>
            <Link
              to="/category/exclusive"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-800"
            >
              <i className="ri-flashlight-fill" /> 进栏吃独家
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="lg:col-span-2">
            {lead && (
              <Link
                to={`/news/${lead.id}`}
                className="group mb-3 flex flex-col gap-4 rounded-2xl border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 sm:flex-row"
              >
                <div className="relative h-44 w-full shrink-0 overflow-hidden rounded-xl sm:h-40 sm:w-56">
                  <img
                    src={lead.cover}
                    alt={`${lead.title} 独家内容配图`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-col justify-center p-1 sm:p-2">
                  <span className="mb-2 inline-flex w-fit items-center gap-1 rounded-full bg-primary-600 px-2.5 py-0.5 text-[11px] font-semibold text-background-50">
                    <i className="ri-flashlight-fill" /> 本期头条内幕
                  </span>
                  <h3 className="font-heading text-lg font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
                    {lead.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                    {lead.lead}
                  </p>
                </div>
              </Link>
            )}
            <div className="space-y-2">
              {rest.map((item) => (
                <ListRow key={item.id} item={item} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}